import React, { useEffect, useRef } from 'react';
import Hls from 'hls.js';
import './VideoPlayer.css';

const VideoPlayer = ({ link, isModalOpen, isRadio = false }) => {
  const videoRef = useRef(null);
  const hlsInstance = useRef(null);
  const canvasRef = useRef(null);
  const audioContextRef = useRef(null);
  const analyserRef = useRef(null);
  const animationFrameRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;

    console.log('isModalOpen',isModalOpen)

    if (Hls.isSupported()) {
      const hls = new Hls({
        maxBufferLength: 30,    
        maxMaxBufferLength: 30, 
        maxBufferSize: 50 * 1000 * 1000,
        maxBufferHole: 1,
        startLevel: -1
      });
      hlsInstance.current = hls;
      hls.loadSource(link);
      hls.attachMedia(video);
      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        video.play().catch(error => {
          console.error("Erro ao reproduzir o vídeo automaticamente:", error);
        });
      });
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = link;
      video.addEventListener('loadedmetadata', () => {
        video.play().catch(error => {
          console.error("Erro ao reproduzir o vídeo automaticamente:", error);
        });
      });
    }

    return () => {
      if (hlsInstance.current) {
        hlsInstance.current.destroy();
      }
      if (video) {
        video.pause();
        video.src = '';
      }
    };
  }, [link]);

  useEffect(() => {
    if (isModalOpen !== undefined && !isModalOpen && videoRef.current) {
      videoRef.current.pause();
    }
  }, [isModalOpen]);

  useEffect(() => {
    if (!isRadio) return undefined;

    const audio = videoRef.current;
    const canvas = canvasRef.current;
    if (!audio || !canvas) return undefined;

    const connectAnalyser = () => {
      if (audioContextRef.current) {
        audioContextRef.current.resume();
        return;
      }

      try {
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const analyser = audioContext.createAnalyser();
        analyser.fftSize = 128;
        analyser.smoothingTimeConstant = 0.82;

        const source = audioContext.createMediaElementSource(audio);
        source.connect(analyser);
        analyser.connect(audioContext.destination);
        audioContextRef.current = audioContext;
        analyserRef.current = analyser;
      } catch {
        // Mantem a animacao de espera quando o navegador nao libera o analisador.
      }
    };

    const drawWaveform = () => {
      animationFrameRef.current = requestAnimationFrame(drawWaveform);

      const width = canvas.offsetWidth;
      const height = canvas.offsetHeight;
      if (!width || !height) return;
      if (canvas.width !== width) canvas.width = width;
      if (canvas.height !== height) canvas.height = height;

      const context = canvas.getContext('2d');
      context.clearRect(0, 0, width, height);

      const barCount = 40;
      const gap = 3;
      const barWidth = (width - gap * (barCount - 1)) / barCount;
      const analyser = analyserRef.current;
      const idleTime = Date.now() / 900;

      const frequencies = analyser ? new Uint8Array(analyser.frequencyBinCount) : null;
      if (frequencies) analyser.getByteFrequencyData(frequencies);

      for (let index = 0; index < barCount; index += 1) {
        const level = frequencies
          ? frequencies[index * Math.floor(analyser.frequencyBinCount / barCount)] / 255
          : Math.sin(idleTime + index * 0.45) * 0.1 + 0.16;
        const barHeight = Math.max(3, level * height * (frequencies ? 0.92 : 1));
        const x = index * (barWidth + gap);
        const y = height - barHeight;
        const gradient = context.createLinearGradient(0, height, 0, 0);
        gradient.addColorStop(0, '#121926');
        gradient.addColorStop(0.5, '#12192677');
        gradient.addColorStop(1, '#12192627');
        context.fillStyle = gradient;
        context.beginPath();
        if (context.roundRect) context.roundRect(x, y, barWidth, barHeight, 2);
        else context.rect(x, y, barWidth, barHeight);
        context.fill();
      }
    };

    audio.addEventListener('play', connectAnalyser);
    animationFrameRef.current = requestAnimationFrame(drawWaveform);

    return () => {
      audio.removeEventListener('play', connectAnalyser);
      cancelAnimationFrame(animationFrameRef.current);
    };
  }, [isRadio]);

  return (
    <div className={`video-container${isRadio ? ' video-container--radio' : ''}`}>
      {isRadio ? (
        <div className="radio-player">
          <canvas ref={canvasRef} className="radio-player__waveform" />
          <p className="radio-player__label">Radio</p>
          <audio
            ref={videoRef}
            controls
            playsInline
            className="radio-player__audio"
          />
        </div>
      ) : (
        <video
          ref={videoRef}
          controls
          width="100%"
          height="auto"
          playsInline
          webkit-playsinline="true"
        />
      )}
    </div>
  );
};

export default VideoPlayer;
